import arrowRight from "../assets/arrow-right.png";
import zoomIcon from "../assets/zoom-icon.png";
import gmeetIcon from "../assets/meet-icon.png";
import youtubeIcon from "../assets/yt-icon.png";
export default {
  arrowRight,
  zoomIcon,
  gmeetIcon,
  youtubeIcon,
};
